import React from 'react';
import { Box } from '@mui/material';

import { getRolloutBanner } from '../../service/rolloutBanner';

// KBT-188 — renewal-season notice on the Membership page (members-only
// window, early-commit deadline). Renders nothing outside the renewal
// season, so the page looks exactly as before the rest of the year.
export default function RolloutBanner({ rollout, signedIn = false }) {
  const banner = getRolloutBanner(rollout, { signedIn });
  if (!banner) return null;

  return (
    <Box
      role="status"
      data-testid="membership-rollout-banner"
      sx={{
        maxWidth: 960,
        mx: 'auto',
        mt: { xs: 3, md: 4 },
        px: { xs: 2, md: 0 },
      }}
    >
      <Box
        sx={{
          p: { xs: 2.5, md: 3 },
          borderLeft: '4px solid var(--teal-500, #0F75BC)',
          background: 'rgba(15,117,188,0.06)',
          fontFamily: 'var(--font-body)',
          color: 'var(--navy-500, #242258)',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'flex-start', md: 'center' },
          gap: 2,
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Box sx={{ fontWeight: 700, fontSize: 16, mb: 0.5 }}>{banner.title}</Box>
          <Box sx={{ fontSize: 14.5, lineHeight: 1.6 }}>{banner.body}</Box>
        </Box>
        {banner.cta && (
          <Box
            component="a"
            href={banner.cta.href}
            sx={{
              flexShrink: 0,
              px: 2.5,
              py: 1.25,
              background: 'var(--navy-500, #242258)',
              color: '#fff',
              fontWeight: 700,
              fontSize: 13,
              letterSpacing: '0.04em',
              textDecoration: 'none',
              textTransform: 'uppercase',
            }}
          >
            {banner.cta.label}
          </Box>
        )}
      </Box>
    </Box>
  );
}
